// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".oh-data.oh-status.shipped[data-v-24700c3c]{color:#06a77d}.oh-data.oh-status.processing[data-v-24700c3c]{color:#efa00b}.oh-data.oh-status.contact[data-v-24700c3c],.oh-data.oh-status.pending[data-v-24700c3c]{color:#a63446}.oh-data.strong[data-v-24700c3c]{font-weight:700}.order-details-content[data-v-24700c3c]{cursor:pointer}.order-details-content[data-v-24700c3c]:hover{background-color:#eaeaeb}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
